import GalleryCard from './gallery-card';

export default GalleryCard;
